import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './style.scss'
import FormData from './components/FormData/FormData'
import Modal from 'react-modal';
import { changeLabelQuestion } from './actions'
import Spiner from '../../../../../helpers/Spiner/Spiner'

class Labels extends Component {
  constructor(props) {
    super(props)
    this.state = {
       show: false,
       loaded: true,
       labelQuestions: props.question && props.question.labels ? props.question.labels: []
    }
  }

  onChangeLabel = async (label) => {
    const {question} = this.props;
    const { labelQuestions } = this.state;
    if(labelQuestions.some(_l => _l.label_id == label.id)){
      this.setState({
        labelQuestions: labelQuestions.filter(_l => _l.label_id != label.id),
        loaded: false
      })
    } else {
      this.setState({labelQuestions: [...labelQuestions, {label_id: label.id, question_id: question.id}], 
        loaded: false
      })
    }
    await changeLabelQuestion({
      label_id: label.id,
      question_id: question.id,
    })
    this.setState({loaded: true})
  } 

  render() {
    const {question, formatMessage, labels} = this.props;
    const { show, labelQuestions, loaded } = this.state;

    return (
      <div className='Labels'>
        <Modal
          isOpen = {show}
          style = {{
              overlay : {zIndex: 1111},
          }}
          onRequestClose={() => {this.setState({show: false})}}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('titleModalLabels')}</div>
          </div>
          <div className="create-dialog-modal-content__body">
            {!loaded && <div style={{position: 'absolute', top: '0', width: '100%', height: '100%', left: '0', zIndex: 2, background: 'rgba(255,255,255, 0.4)'}}><Spiner /></div>}
            <FormData 
              onClose={() => this.setState({show: false})} 
              formatMessage={formatMessage} 
              labelQuestions={labelQuestions} 
              onChangeLabel={this.onChangeLabel} 
            /> 
          </div>
        </Modal>
        <div className='label_title' onClick={() => {this.setState({show: true})}}>{formatMessage('titleQuestionLabels')}:</div>
        <div className='items'>
          {labels.filter(_i => labelQuestions.some(_l => _i.id == _l.label_id)).map((_i) => <div className='item_label' style={{background: _i.color}}>
            {_i.text}
          </div>)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  labels: state.label.list,
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Labels)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/Labels.jsx